import { render, staticRenderFns } from "./currency-form.vue?vue&type=template&id=99c38222&"
import script from "./currency-form.vue?vue&type=script&lang=ts&"
export * from "./currency-form.vue?vue&type=script&lang=ts&"
import style0 from "./currency-form.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports